import { ItemsDetails } from "../../../main/components/ItemsDetails";
import { Item } from "../../users/components/UserItemsTable";
import { Usina } from "../../usinas/types";
import { useNavigate } from "react-router-dom";
import { Client } from "../types";
import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import { RemoveUsinaModals } from "../../users/components/RemoveUsinaModals";
import { AddItemModals } from "../../users/components/AddItemModals";
import { clientsApi, usinasApi } from "../../../services/api";
import { InputAdornment, Stack, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function ClientEditBodyPageUsina() {
  const navigate = useNavigate();
  const { userIsAdm } = useContext(MainContext);
  const [client, setClient] = useState<Client | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [usinas, setUsinas] = useState<Usina[]>([]);
  const [selectedUsina, setSelectedUsina] = useState<Item | null>(null);
  const [showAddUsinaModal, setShowAddUsinaModal] = useState<boolean>(false);
  const [showRemoveUsinaModal, setShowRemoveUsinaModal] =
    useState<boolean>(false);
  const path = window.location.pathname;
  const clientId = path.split("/")[2];

  const permittedUsinas = usinas.filter((u) =>
    client?.usinasIds?.includes(u.usinaIds.id)
  );

  const onConfirmRemoveUsina = async () => {
    if (!selectedUsina || !client) return;
    await clientsApi.removeUsina(client.id, [selectedUsina.id ?? ""]);
  };

  // const onConfirmRemoveUsina = async () => {
  //   if (!selectedUsina || !clients[0]) return;
  //   await clientsApi.removeUsina(clients[0].id, [selectedUsina.id]);
  // };

  const onConfirmAddUsina = async (item: Item) => {
    const updatedPermittedUsinas = [
      ...permittedUsinas
        .map((e) => e.usinaIds.id)
        .filter((id): id is string => id !== undefined),
      item.id,
    ];

    if (client) {
      const filteredPermittedUsinas = updatedPermittedUsinas.filter(
        (id): id is string => typeof id === "string"
      );

      await clientsApi.addUsina(client.id, filteredPermittedUsinas);
    }
  };

  const onRemoveUsina = async (item: Item) => {
    setSelectedUsina(item);
    setShowRemoveUsinaModal(true);
  };

  useEffect(() => {
    onMount();
  }, []);

  const onMount = async () => {
    try {
      const clientResponse = await clientsApi.getClient(clientId);
      const usinasResponse = await usinasApi.getUsinas();
      setClient(clientResponse);
      setUsinas(usinasResponse.data);
    } catch (error) {
      throw new Error("Erro ao carregar cliente");
    }
  };

  const filteredUsinas = permittedUsinas.filter((usina) =>
    usina.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Stack marginTop="20px">
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "14px", md: "17px" },
            marginTop: { xs: "-5px", md: "5px" },
            textAlign: "left",
            height: "34px",
          }}
        >
          Usinas
        </Typography>
        <TextField
          placeholder="Pesquisar Usina"
          variant="standard"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ width: "20px", height: "20px" }} />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <ItemsDetails
        hover
        style={{
          display: "flex",
          alignItems: "flex-start",
          height: "100%",
        }}
        removeActions={!userIsAdm}
        items={
          filteredUsinas.map((e) => {
            return {
              id: e.usinaIds.id || "",
              name: e.name || "",
              onClick: () => {
                navigate(`/usinas/${e.usinaIds.id}`);
              },
            };
          }) || []
        }
        itemLabel="usina"
        onAdd={() => {
          setShowAddUsinaModal(true);
        }}
        onRemove={onRemoveUsina}
      />

      <RemoveUsinaModals
        onConfirmRemoveUsina={onConfirmRemoveUsina}
        showRemoveUsinaModal={showRemoveUsinaModal}
        setShowRemoveUsinaModal={setShowRemoveUsinaModal}
        usinaName={selectedUsina?.name || ""}
        onMount={onMount}
      />

      <AddItemModals
        itemName="Usina"
        itemText="a usina"
        items={usinas
          .filter((u) => !client?.usinasIds?.includes(u.usinaIds.id))
          .map((usina) => {
            return { id: usina.usinaIds.id, name: usina.name };
          })}
        onConfirmAddItem={onConfirmAddUsina}
        setShowAddItemModal={setShowAddUsinaModal}
        showAddItemModal={showAddUsinaModal}
        onMount={onMount}
      />
    </>
  );
}
